module.exports = __webpack_public_path__ + "fonts/montserrat-latin-800italic.fe82abb.woff";